import { MouseEvent, useCallback, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { SNACKBAR_SKIN } from 'components/shared/Snackbar';
import { GENERAL_ERROR_MESSAGE } from 'constants/texts';
import { showSnackbar } from 'hooks/useSnackbar';
import { setItinerariesItemDataAction } from 'store/itinerariesItem';
import { itinerariesItemDataSelector } from 'store/itinerariesItem/selectors';
import { setAppHasChangesAction } from 'store/unsavedChanges';
import { confirmAlert } from 'utils/alert';

import { getDefaultFilter } from '../functions';
import { IDetailsSearchFilter, IDetailsSearchFilterReturn, IFilter } from './types';

export const useItineraryDetailsSearchFilter = ({
  filter,
  filterName,
  filterKeyName,
}: IDetailsSearchFilter): IDetailsSearchFilterReturn => {
  const itinerary = useSelector(itinerariesItemDataSelector);
  const dispatch = useDispatch();

  const showRadioButtons = true;
  const defaultFilter = useMemo(() => getDefaultFilter(), []) as IFilter;
  const restoredFilter = useMemo(() => filter || getDefaultFilter(filter), [filter]);

  const handleDelete = useCallback(
    (e: MouseEvent<HTMLDivElement>) => {
      e.preventDefault();
      e.stopPropagation();

      confirmAlert({
        title: 'Are you sure you want to delete this filter?',
        onConfirm: async () => {
          try {
            dispatch(
              setItinerariesItemDataAction({
                ...itinerary,
                [filterKeyName]: null,
              }),
            );
            dispatch(setAppHasChangesAction(true));
          } catch (err) {
            //@ts-ignore
            showSnackbar({ text: GENERAL_ERROR_MESSAGE, type: SNACKBAR_SKIN.ERROR });
          }
        },
      });
    },
    [filterKeyName, itinerary],
  );

  const handleSave = useCallback(
    async (newFilter: IFilter) => {
      dispatch(
        setItinerariesItemDataAction({
          ...itinerary,
          [filterKeyName]: newFilter,
        }),
      );
      dispatch(setAppHasChangesAction(true));
      //@ts-ignore
      showSnackbar({ text: 'Filters have been saved.' });
    },
    [filterKeyName, itinerary],
  );

  return {
    title: `Filter ${filterName}`,
    defaultFilter,
    restoredFilter,
    showRadioButtons,
    handleDelete,
    handleSave,
  };
};
